module.exports = "/_next/static/images/ConnectAndSync-f00ededd3092d4ba17b408ad4e29e9b3.webp";